import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifInput,
  MotifFormField,
  MotifErrorMessage,
} from '@ey-xd/motif-react';
import { Field, reduxForm } from 'redux-form';
import * as formHelpers from '../../../scripts/formHelpers';

const DeleteSecurityConfirmationModal = ({
  showDeleteSecurityConfirmationModal,
  toggleShowDeleteSecurityConfirmationModal,
  handleConfirm,
  handleSubmit,
  deleteSecurity,
  validationMessage,
  handleDismissErrorMessage,
}) => {
  const [confirmationInputText, setConfirmationInputText] = useState('');
  const [saveEnabled, setSaveEnabled] = useState(false);

  useEffect(() => {
    if (showDeleteSecurityConfirmationModal) {
      setConfirmationInputText('');
      setSaveEnabled(false);
    }
  }, [showDeleteSecurityConfirmationModal]);

  const handleConfirmationInput = (e) => {
    setConfirmationInputText(e.target.value);
    if (/^Delete$/gi.test(e.target.value)) {
      setSaveEnabled(true);
    } else {
      setSaveEnabled(false);
    }
  };
  const showHideConfirmationModal = () => {
    setConfirmationInputText('');
    toggleShowDeleteSecurityConfirmationModal();
  };

  const closeButtonProps = {
    title: 'Delete Security',
    'aria-label': 'Delete Security',
    'data-testid': 'close',
  };
  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(deleteSecurity)();
  };
  return (
    <MotifModal
      show={showDeleteSecurityConfirmationModal}
      data-testid="divDeleteSecurityModal"
      onClose={showHideConfirmationModal}
      variant="default"
      size="lg"
    >
      <form onSubmit={onSubmit} id="deleteSecurityForm">
        <MotifModalHeader
          closeButtonProps={closeButtonProps}
          data-testid="mdHdrdeleteSecurity"
        >
          Delete Security
        </MotifModalHeader>
        <MotifModalBody>
          {formHelpers.showSubmissionError(
            validationMessage,
            handleDismissErrorMessage
          )}
          <MotifFormField>
            <div className="row">
              <div className="field col-md-12">
                <Field
                  name="securityName"
                  component={formHelpers.renderField}
                  type="text"
                  label="Security Name"
                  data-testid="txtSecurityName"
                  className="w-100"
                  disabled={true}
                />
              </div>
            </div>
          </MotifFormField>
          <span className="margin-bottom-1">
            Type &apos;Delete&apos; in the box below to confirm you want to make
            this change.
          </span>
          <div className="row">
            <div className="field col-md-12">
              <MotifInput
                type="text"
                name="confirmationInput"
                id="confirmationInput"
                onChange={handleConfirmationInput}
                value={confirmationInputText}
                required={true}
                placeholder="Delete"
                data-testid="txtDelete"
              />
            </div>
          </div>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            variant="secondary"
            className="right mt-3"
            onClick={() => {
              setConfirmationInputText('');
              toggleShowDeleteSecurityConfirmationModal();
            }}
            data-testid="btnCancel"
            type="button"
          >
            Cancel
          </MotifButton>
          <MotifButton
            variant="primary"
            className="right mt-3"
            data-testid="btnConfirm"
            onClick={handleConfirm}
            type="submit"
            disabled={!saveEnabled}
          >
            Confirm
          </MotifButton>
        </MotifModalFooter>
      </form>
    </MotifModal>
  );
};

DeleteSecurityConfirmationModal.propTypes = {
  showDeleteSecurityConfirmationModal: PropTypes.bool,
  toggleShowDeleteSecurityConfirmationModal: PropTypes.func,
  modifiedMappingsArray: PropTypes.array,
  handleConfirm: PropTypes.func,
  deleteSecurity: PropTypes.func,
  theme: PropTypes.string,
  initialValues: PropTypes.shape({
    SecurityID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SecurityName: PropTypes.string,
  }),
  handleSubmit: PropTypes.func,
};
export default reduxForm({
  form: 'deleteSecurityForm',
  enableReinitialize: true,
})(DeleteSecurityConfirmationModal);
